/**
 * 購入開始処理のStateを扱うモジュール
 *
 * Spinnerボタンの追加に伴い、
 * プラン一覧画面で購入開始処理中のプランを
 * 把握することが必要になったため追加
 */
import { ActionsUnion, createAction } from 'common/utils/action-utils';

export enum ActionTypes {
  RESET_PURCHASE_SESSION_PLAN_ID = 'app/PurchaseSession/RESET_PURCHASE_SESSION_PLAN_ID',
  SET_PURCHASE_SESSION_PLAN_ID = 'app/PurchaseSession/SET_PURCHASE_SESSION_PLAN_ID'
}

/**
 * 購入開始処理実行中のプランIDをクリアする
 */
export const resetPurchaseSessionPlanId = () =>
  createAction(ActionTypes.RESET_PURCHASE_SESSION_PLAN_ID);

/**
 * 購入開始処理実行中のプランIDを設定する
 * @param {string} planId 購入開始処理実行中のプランID
 */
export const setPurchaseSessionPlanId = (planId: string) => {
  return createAction(ActionTypes.SET_PURCHASE_SESSION_PLAN_ID, planId);
};

const actions = {
  resetPurchaseSessionPlanId,
  setPurchaseSessionPlanId
};
type PurchaseSessionAction = ActionsUnion<typeof actions>;

/**
 * 購入開始実行中のState
 */
export interface PurchaseSessionState {
  /** 購入開始処理実行中のプランID */
  planId: string;
}

const initialState: PurchaseSessionState = {
  planId: ''
};

export default (
  state: PurchaseSessionState = initialState,
  action: PurchaseSessionAction
): PurchaseSessionState => {
  switch (action.type) {
    case ActionTypes.RESET_PURCHASE_SESSION_PLAN_ID:
      return { ...state, planId: '' };
    case ActionTypes.SET_PURCHASE_SESSION_PLAN_ID:
      return { ...state, planId: action.payload };
    default:
      return state;
  }
};
